import { Injectable } from '@angular/core';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private encryptionService: EncryptionService) {}

  setLocalStorageData(key: string, data: any) {
    const encryptedData = this.encryptionService?.encrypt(JSON.stringify(data));
    localStorage.setItem(key, encryptedData);
  }

  getLocalStorageData(key: string) {
    const encryptedData: string = localStorage.getItem(key)!;
    let decryptedData = null;
    if (encryptedData) {
      decryptedData = JSON.parse(
        this.encryptionService?.decrypt(encryptedData)
      );
    }

    return decryptedData;
  }

  clearLocalStorage() {
    localStorage.clear();
  }

  removeValue(key: string) {
    localStorage.removeItem(key);
  }
}
